// VIEWER COMPANIONS — the client half: PRESENTATION ONLY.
//
// The DECISION of which companions a viewer's speed dial shows is made ONCE,
// server-side, by shared/viewer-companions.js and returned by
// GET /api/apps/resolve/:view as `companions: ['chat','pipeline',…]` (ordered).
// Nothing in this file recomputes it, narrows it, or probes for data to
// second-guess it. That is the whole point of the module existing.
//
// WHY (bug, Alex 2026-08-27): "why the hell all variants have different options
// of speed dial, it should be the same everywhere and should show only toggled".
// Three client dials each had their own list:
//
//   * SharedApp.jsx gated guides/pipeline/governance/docs on
//     viewer_scope === 'full', so a share recipient signed in as an app_user
//     (share pass-through ⇒ 'shared_only') saw ONE chat bubble;
//   * AssistantChat.jsx (the in-cortex app view dial) hardcoded
//     Chat/Pipeline/Governance and data-probed Workflows/Guides, never reading
//     viewer_chrome — so Workflows appeared while toggled OFF and Guides did
//     not appear while toggled ON;
//   * the exported deployment dial honored its frozen snapshot but re-probed
//     guides/workflows/chat and rendered no Docs at all.
//
// Now all three map the server's list through COMPANION_ORDER and render it.
// A companion toggled OFF cannot appear, because it is not in the list.
//
// AUTHZ IS UNCHANGED AND STILL SERVER-SIDE. Each companion's backing route
// keeps its own gate (backend/server.js's project PEP, /api/wf/engine's
// SHARED_ONLY_ACTIONS, /api/docs/engine's read/write split, portal-api's
// public-viewer refusal). This list decides what a viewer is OFFERED; the
// server decides what the button may do. Hiding is defense in depth, not the
// defense.

// Dial order, top of the fan to bottom. Must match shared/viewer-companions.js
// COMPANIONS so a viewer moving between surfaces sees stable geometry.
export const COMPANION_ORDER = ['chat', 'workflows', 'guides', 'pipeline', 'governance', 'docs'];

// Per-companion chrome. `page` is the embed page a companion opens (chat and
// guides are special: chat opens the chat panel, guides run a tour), `label` is
// what the button says, `bg` its colour — identical values across all three
// dials so the same companion looks the same everywhere.
export const COMPANION_CHROME = {
  chat:       { label: 'Chat',        bg: '#15803d', page: null },
  workflows:  { label: 'Workflows',   bg: '#0f172a', page: 'workflows' },
  guides:     { label: 'Guides',      bg: '#7c3aed', page: null },
  pipeline:   { label: 'Pipeline',    bg: '#4f46e5', page: 'pipeline' },
  governance: { label: 'Governance',  bg: '#059669', page: 'data-dictionary' },
  docs:       { label: 'Docs',        bg: '#b45309', page: 'docs' },
};

// Normalize whatever the resolve returned into an ordered, de-duplicated list
// of KNOWN companion names.
//
// `null`/`undefined` (an older backend that does not send the field yet) yields
// null, meaning "not curated" — the caller then keeps its prior behavior rather
// than rendering an empty dial. An EMPTY ARRAY is a real answer: nothing
// enabled, empty corner.
export function companionsFrom(resolved) {
  const list = resolved?.companions;
  if (!Array.isArray(list)) return null;
  return COMPANION_ORDER.filter((k) => list.includes(k));
}

// Membership test against a normalized list. Mirrors companionAllowed() in
// shared/viewer-companions.js, including its fail-open on an uncurated list.
export const companionOn = (list, key) => (list == null ? true : list.includes(key));
